import _ from 'root/libs/exaforte/react/lodash';
import Config from 'root/globals/Config';

export const __IS_MANDATORY__               = 'is verplicht';
export const __INVALID_EMAIL__              = 'is een ongeldig e-mail adres';
export const __INVALID_INTEGER__            = 'is een ongeldig getal'
export const __INVALID_DATE__               = 'is een ongeldige datum';
export const __INVALID_TIME__               = 'is een ongeldige tijd';
export const __CONTENT_TYPE_DEFAULT__       = 1;
export const __CONTENT_TYPE_PASSWORD__      = 2;
export const __CONTENT_TYPE_EMAIL__         = 3;
export const __CONTENT_TYPE_DATE__          = 4;
export const __CONTENT_TYPE_MONEY__         = 5;
export const __CONTENT_TYPE_INTEGER__       = 6;
export const __CONTENT_TYPE_URL__           = 7;
export const __CONTENT_TYPE_TEXTAREA__      = 8;
export const __CONTENT_TYPE_PHP__           = 9;
export const __CONTENT_TYPE_EDITOR__        = 10;
export const __CONTENT_TYPE_BOOLEAN__       = 11;
export const __CONTENT_TYPE_FILE__          = 12;
export const __CONTENT_TYPE_IMAGE__         = 13;
export const __CONTENT_TYPE_SELECT__        = 14;
export const __CONTENT_TYPE_CSS__           = 15;
export const __CONTENT_TYPE_JAVASCRIPT__    = 16;
export const __CONTENT_TYPE_SQL__           = 17;
export const __CONTENT_TYPE_DATETIME__      = 18;
export const __CONTENT_TYPE_PHONENUMBER__   = 19;
export const __CONTENT_TYPE_FAXNUMBER__     = 20;
export const __CONTENT_TYPE_ZIPCODE__       = 21;
export const __CONTENT_TYPE_MOBILENUMBER__  = 22;
export const __CONTENT_TYPE_COLOR__         = 23;
export const __CONTENT_TYPE_TIME__          = 24;
export const __CONTENT_TYPE_HIDDEN__        = 25;
export const __CONTENT_TYPE_JSON__          = 26;
export const __CONTENT_TYPE_JSON_LONG__     = 27;
export const __CONTENT_TYPE_TEXTAREA_LONG__ = 28;
export const __CONTENT_TYPE_MOBILE_NUMBER__ = 29;
export const __CONTENT_TYPE_TIMESTAMP__     = 32;
export const __CONTENT_TYPE_PERCENTAGE__    = 33;
export const __CONTENT_TYPE_FLOAT__         = 34;

export default class ReactModel
{
    constructor(config)
    {
        this.components = {};
        
        this.reset(config)
    }
    
    reset(config)
    {
        let random_id = 'new-' + new Date().getTime() + '.' + Math.floor((1 + Math.random()) * 0x10000);
        
        if((!config || !config.data || !config.data.id) && config.controller && ((config.controller.component.state.models && config.controller.component.state.models[config.name]) || (config.controller.component.models && config.controller.component.models[config.name])))
            while((config.controller.component.state.models && config.controller.component.state.models[config.name] && config.controller.component.state.models[config.name][random_id]) || (config.controller.component.models && config.controller.component.models[config.name] && config.controller.component.models[config.name][random_id]))
                random_id = 'new-' + new Date().getTime() + '.' + Math.floor((1 + Math.random()) * 0x10000);

        this.config             = {...{controller: null, name: null, component: null, save_url: Config.SERVER_REQUEST_URL + '?ajax_id=36&component=' + config.name + '&form-action=edit', init_empty: false, get_data_from_state: true}, ...config};
        this.name               = null;
        this.bind_id            = config.bind_id || 'id';
        this.saving             = false;
        this.data               = {...{id: random_id, removed: 'f', component_id: config.name}, ...config.data};
        this.errors             = {};
        this.warnings           = {};
        this.ignore_warnings    = false;
        this.start_data         = {};
        this.fielddefines       = {};
        this.changed_data       = {};
        this.update             = _.debounce(this.update.bind(this), 200);

        if(config.controller)
        {
            this.set_component_name(config.name);

            if(config.controller.component.state.fielddefines && config.controller.component.state.fielddefines[this.name])
            {
                this.fielddefines = config.controller.component.state.fielddefines[this.name];
                
                if(!this.has_data())
                    for(let i in this.fielddefines)
                        if(!this.data[this.fielddefines[i].field] && !_.is_empty(this.fielddefines[i].value))
                            this.data[this.fielddefines[i].field] = this.fielddefines[i].value;
            }
            
            if(this.has_data() && this.get_bind_id() && this.exists_in_state() && this.config.get_data_from_state)
                this.data = {...{removed: 'f'}, ..._.cloneDeep(config.controller.component.state.models[config.name][this.get_bind_id()])};
        }

        if(this.has_data())
            this.start_data = _.cloneDeep(this.data)
        
        if(this.config.component)
            this.addComponent(this.config.component);
    }
    
    reset_data_to_state(settings)
    {
        settings = {remove_if_no_changes: true, ...settings};

        // Als hij niet in de state bestond, is het een nieuw record en kunnen we hem dus verwijderen.
        if(!this.exists_in_state())
            this.remove({force: true});
        else
        {
            this.data           = _.cloneDeep(this.config.controller.component.state.models[this.name][this.get_bind_id()]);
            this.changed_data   = {};
            this.errors         = {};
            
            for(let field in this.data)
            {
                if(!_.isEqual(_.format_input(_.cloneDeep(this.data[field])), _.format_input(_.cloneDeep(this.start_data[field]))))
                    this.changed_data[field] = true;
            }

            // Als er hierna geen changes meer zijn hoeven we het model ook niet te bewaren
            if(settings.remove_if_no_changes && !this.has_changes())
                this.remove({force: true});
        }
    }
    
    addComponent(component)
    {
        this.components[component.constructor.name] = component;
        var currentMethod                           = (component.componentWillUnmount ? component.componentWillUnmount.bind(component) : null);
        var addedComponent                          = component;
        component.componentWillUnmount              = () => {
            if(typeof addedComponent != 'undefined')
                this.removeComponent(addedComponent);
            
            if(typeof addedComponent != 'undefined' && typeof currentMethod != 'undefined' && currentMethod != null)
                currentMethod();
        }
    }
    
    removeComponent(component)
    {
        if(this.components[component.constructor.name])
            delete this.components[component.constructor.name];
    }
    
    setSavingState(saving)
    {
        this.saving = saving;
        
        if(_.size(this.components) > 0)
            for(let name in this.components)
                this.components[name].setState({saving: this.saving});
    }
    
    get_field_props(settings)
    {
        settings    = {...{changeCallbackProp: 'onChangeText', field: null, withValue: true, valueField: 'value', value: this.get_field_data(settings.field), fielddefine: {}}, ...settings};
        let props   = [];
        
        if(_.is_empty(settings.fielddefine) && this.fielddefines[settings.field])
            settings.fielddefine = this.fielddefines[settings.field];

        props = {...props, ...settings.fielddefine};
        
        if(!settings.changeCallback)
            settings.changeCallback = (val) => { this.set_field_data({field: settings.field, value: val, trigger_after_field_change_update: (!props.is_uncontrolled || this.environment == 'native'), ...(settings.set_field_data_settings ? settings.set_field_data_settings : {})}); };

        if(settings.withValue)
            props[settings.valueField] = settings.value;
        
        props[settings.changeCallbackProp]  = settings.changeCallback;
        props.mandatory                     = (props.mandatory === true || props.mandatory == 't');

        if(this.errors[settings.field])
            props.error = this.errors[settings.field];
        if(this.warnings[settings.field])
            props.warning = this.warnings[settings.field];

        return props;
    }
    
    get_data(data)
    {
        if(!data)
            data = this.data;
        
        return data;
    }
    
    get_fielddefine_data()
    {
        let data = {};

        for(let field in this.fielddefines)
            data[field] = this.data[field];

        return data;
    }
    
    get_changed_data()
    {
        let changed_data = {};
        
        if(this.has_changes())
        {
            // init_empty wordt alleen opgeslagen als je een wijziging maakt op de basis gegevens. Dan wordt hij gewoon als volledig commit gezien. Maar alleen wanneer het een nieuw record is.
            if(this.config.init_empty && !this.has_data())
                return this.get_data();
            
            changed_data['id']          = this.data.id;
            changed_data[this.bind_id]  = this.get_bind_id();
        }
        
        for(let key in this.changed_data)
            changed_data[key] = this.data[key];
            
        return this.get_data(changed_data);
    }
    
    set_field_data(settings)
    {
        settings = {...{force_change: (!_.is_empty(this.config.controller) && _.has_object_chain(this.config.controller.component.state, {chain: ['fielddefines', this.config.name, settings.field], allow_empty_value: false}) && (this.config.controller.component.state.fielddefines[this.config.name][settings.field].checktype_id == __CONTENT_TYPE_FILE__ || this.config.controller.component.state.fielddefines[this.config.name][settings.field].checktype_id == __CONTENT_TYPE_IMAGE__)), commit_changes: false, register_change: true, trigger_after_field_change_update: true, trigger_after_field_change: true}, ...settings}
        
        // Bij een concept mag je geen ID aanpassen, omdat die gebruikt wordt bij referenties.
        // Als de waarde niet veranderd is hoeft hij ook niet verder in de code te gaan.
        if(settings.force_change === false && _.isEqual(_.format_input(_.cloneDeep(this.data[settings.field]), {format_numbers: false}), _.format_input(_.cloneDeep(settings.value), {format_numbers: false})))
            return false
        
        // Check hoeft niet gedaan te worden wanneer je het model voor het eerst inlaad. Je wilt niet allemaal meldingen bij page load krijgen.
        if(this.before_field_change_callback(settings))
        {
            // Het id is een referentie bij de parent container. Als die wordt aangepast (bijv. na een create) moet de referentie in de parent containers ook aangepast worden.
            if(settings.field == this.bind_id && settings.value != this.get_bind_id())
            {
                this.config.controller.models[this.name][settings.value] = this
                
                delete this.config.controller.models[this.name][this.get_bind_id()]
            }
            
            settings.old_value          = this.data[settings.field]
            this.data[settings.field]   = settings.value
            
            // Als er al een change voor geregistreerd staat en de waarde wordt teruggezet naar wat die was, kan de change verwijderd worden
            if(this.changed_data[settings.field] && ((!this.start_data[settings.field] && _.is_empty(this.data[settings.field])) || _.isEqual(_.format_input(this.data[settings.field], {string_to_lower: false}), _.format_input(this.start_data[settings.field], {string_to_lower: false}))) && settings.force_change === false)
                delete this.changed_data[settings.field]
            else if(settings.register_change)
                this.changed_data[settings.field] = true
            
            if(settings.trigger_after_field_change)
                this.after_field_change_callback(settings)
        }
    }
    
    set_component_name(name)
    {
        // Niks veranderd
        if(this.name == name)
            return;

        const apply_data_to_state_models = {};
        
        if(!_.is_empty(this.name) && this.config.controller)
        {
            if(this.get_bind_id() !== undefined)
                delete this.config.controller.models[this.name][this.get_bind_id()];
            else if(_.size(this.config.controller.models[this.name]) === 0)
                delete config.controller.models[this.name];
            
            if(this.config.controller.component.state.fielddefines && this.config.controller.component.state.fielddefines[name])
            {
                this.fielddefines = this.config.controller.component.state.fielddefines[name];
                
                if(!this.has_data())
                    for(let i in this.fielddefines)
                        if(!this.data[this.fielddefines[i].field] && !_.is_empty(this.fielddefines[i].value))
                            this.data[this.fielddefines[i].field] = this.fielddefines[i].value;
            }
            
            if(this.exists_in_state() && !_.is_empty(this.name))
            {
                _.set_object_chain(apply_data_to_state_models, {chain: [this.name, this.get_bind_id()], value: {id: this.get_field_data('id'), removed: 't'}});
                _.set_object_chain(apply_data_to_state_models, {chain: [name, this.get_bind_id()], value: {...this.config.controller.component.state.models[this.name][this.get_bind_id()], component_id: name}});
            }
        }

        if(this.config.save_url == Config.SERVER_REQUEST_URL + '?ajax_id=36&component=' + this.name + '&form-action=edit')
            this.config.save_url = Config.SERVER_REQUEST_URL + '?ajax_id=36&component=' + name + '&form-action=edit';

        this.name = name;
        
        if(this.config.controller)
        {
            if(!this.config.controller.models[this.name])
                this.config.controller.models[this.name] = {};
    
            if(this.get_bind_id() !== undefined)
                this.config.controller.models[this.name][this.get_bind_id()] = this;
            else if(_.size(this.config.controller.models[this.name]) === 0)
                this.config.controller.models[this.name] = this;
        }

        if(!_.is_empty(apply_data_to_state_models))
            this.apply_data_to_state(apply_data_to_state_models);
    }
    
    get_field_data(field, default_value = null)
    {
        return (typeof this.data[field] === 'undefined' || this.data[field] == null ? default_value : this.data[field])
    }
    
    get_field_start_data(field, default_value = null)
    {
        return (typeof this.start_data[field] === 'undefined' || this.data[field] == null ? default_value : this.start_data[field])
    }
    
    before_field_change_callback(settings)
    {
        return true
    }
    
    after_field_change_callback(settings)
    {
        settings = {...{trigger_after_field_change_update: true}, ...settings};

        if(settings.trigger_after_field_change_update)
            this.direct_update();
    }
    
    update()
    {
        this.direct_update();
    }
    
    direct_update() {
        if(_.size(this.components) > 0)
            for(var i in this.components)
                this.components[i].forceUpdate();
    }
    
    has_data()
    {
        if(typeof this.get_bind_id() == 'undefined')
            return false
        
        return this.get_bind_id().toString().startsWith('new-') === false
    }
    
    save_all_data()
    {
        return (!this.has_data() && !this.config.init_empty);
    }
    
    check_values(settings)
    {
        settings            = {...{update: true, errors: {}, warnings: {}, skip_fields: [], ignore_fields: ['structure_id', 'fielddefine_id']}, ...settings};
        let has_errors      = this.has_errors();
        let has_warnings    = this.has_warnings();
        this.errors         = settings.errors;
        this.warnings       = settings.warnings;

		for(let field in this.fielddefines)
		{
		    if(_.includes(settings.ignore_fields, field))
		        continue;

            if(_.includes(settings.skip_fields, field))
		        continue;

		    let fielddefinefield    = this.fielddefines[field];
			let value               = this.get_field_data(field);
			
			if(fielddefinefield.mandatory == 't' && _.is_empty(value))
				this.errors[field] = fielddefinefield.label + ' ' + __IS_MANDATORY__;
			else if(!_.is_empty(value))
			{
			    switch(parseInt(fielddefinefield.checktype_id))
			    {
			        case __CONTENT_TYPE_EMAIL__:
						if(!_.validEmail(value))
						    this.errors[field] = fielddefinefield.label + ' ' + __INVALID_EMAIL__;
					break;
			        case __CONTENT_TYPE_INTEGER__:
						if(!_.validInt(value))
						    this.errors[field] = fielddefinefield.label + ' ' + __INVALID_INTEGER__;
					break;
			    }
			}
		}

        // has_errors is om te kijken of er eerst wel errors waren die er nu niet meer zijn. Dan kunnen we ook de update triggeren.
		if(settings.update && ((has_errors || this.has_errors()) || (has_warnings || this.has_warnings())))
		    this.update();
    }
    
    has_errors() {
        return _.size(this.errors) > 0;
    }
    
    get_errors() {
        return this.errors;
    }
    
    has_warnings() {
        return !this.ignore_warnings && _.size(this.warnings) > 0;
    }
    
    get_warnings()
    {
        return this.warnings;
    }
    
    commit_changes(settings)
    {
        settings = {...{data: {}, apply_data_to_state: true, reset_start_data: true, reset_changed_data: true, delete_on_removed: !this.has_data(), callback: false}, ...settings};

        // Als het verwijderen is gelukt kan het object weggegooid worden.
        if(this.data.removed == 't' && settings.delete_on_removed)
            this.remove({force: true, apply_data_to_state: settings.apply_data_to_state})
        else
        {
            let bind_id = this.get_bind_id();

            if(settings.data)
                for(let i in settings.data)
                    this.data[i] = settings.data[i];

            if(settings.reset_start_data)
                this.start_data = _.cloneDeep(this.data);

            if(this.config.controller && settings.apply_data_to_state)
            {
                let model = {};

                _.set_object_chain(model, {chain: [this.name, bind_id], value: _.cloneDeep(this.data)});

                if(bind_id != this.get_bind_id())
                {
                    // Nieuw id aanmaken
                    this.config.controller.models[this.name][this.get_bind_id()] = this;
                    
                    // Oude ID verwijderen
                    delete this.config.controller.models[this.name][bind_id];
                }

                this.apply_data_to_state(model, {callback: settings.callback, delete_on_removed: settings.delete_on_removed}, settings.extraData);
            }
            
            if(settings.reset_changed_data)
                this.changed_data = {};
        }
    }
    
    apply_data_to_state(models, settings, extraData)
    {
        this.config.controller.apply_models_to_state(this.config.controller.config.format_data(models), extraData, settings);
    }

    apply_data_to_controller(settings)
    {
        let model = {};

        _.set_object_chain(model, {chain: [this.name, this.get_bind_id()], value: _.cloneDeep(this.data)});

        if(settings.controller)
            settings.controller.apply_models_to_state(model);
    }

    save(settings)
    {
        if(this.saving)
            return Promise.resolve({status: false, response: 104});
        
        settings    = {...{data_as_fields_array: false, url: this.config.save_url}, ...settings}
        let data    = settings.data;

        this.setSavingState(true);
        
        if(this.save_all_data())
            data = this.get_data()
        else if(this.data.removed == 't')
            data = {id: this.data.id, removed: 't'}
        else if(_.size(this.changed_data) > 0)
            data = this.get_changed_data()
        else if(!settings.data)
        {
            this.setSavingState(false);
            
            return Promise.resolve({status: true, response: 105});
        }
        
        settings.body = settings.data_as_fields_array ? {fields: data} : data;
        
        if(this.ignore_warnings && !settings.body.ignore_warnings)
            settings.body.ignore_warnings = 't';
        
        return this.fetch_request(settings);
    }
    
    execute_action(settings) {
        if(this.saving)
            return Promise.resolve({status: false, response: 104});

        if(!this.has_data())
            return Promise.resolve({status: false, response: 105});

        settings        = {...{ajax_id: 36, form_action: 'edit', set_saving_state: true}, ...settings};
        settings.url    = Config.SERVER_REQUEST_URL + '?ajax_id=' + settings.ajax_id + '&component=' + this.name + '&form-action=' + settings.form_action + '&id=' + this.get_field_data('id');

        if(settings.set_saving_state)
            this.setSavingState(true);

        return this.fetch_request(settings);
    }
    
    fetch_request(settings) {
        if(!settings || !settings.retries || settings.retries == 0)
        {
            settings = {...{method: 'POST', xhrFields: { withCredentials: true }, headers: {'X-React-App': 1}, retries: 0, credentials: 'include', debug: false, success: this.save_callback.bind(this), send_node_client_socket_id: true}, ...settings}
        
            if(_.is_empty(settings.url))
                return Promise.resolve({status: false, response: 110, message: 'no url'});

            if(settings.send_node_client_socket_id && this.config.controller && this.config.controller.config.node.server)
            {
                if(_.is_empty(settings.body))
                    settings.body = {};
    
                settings.body.client_socket_id = this.config.controller.config.node.server.id;
            }
            
            if(settings.body)
                settings.body = _.json_to_form_data(settings.body);
        }

        return fetch(settings.url, settings).then((response) => response.text()).then((response) => {
            if(settings.debug)
                console.log(response);

            response = JSON.parse(response);

            this.setSavingState(false);
            
            if(response.status)
            {
                settings.success(response)
                return response;
            }
            else
            {
                let update = false;
                
                if(!_.is_empty(response.warnings))
                {
                    this.warnings   = response.warnings;
                    update          = true;
                }
                else if(!_.is_empty(this.warnings))
                {
                    this.warnings   = {};
                    update          = true;
                }
                
                if(!_.is_empty(response.errors))
                {
                    this.errors = response.errors;
                    update      = true;
                }
                else if(!_.is_empty(this.errors))
                {
                    this.errors = {};
                    update      = true;
                }
                
                if(update)
                    this.direct_update();
                
                return Promise.resolve(response);
            }
        }).catch((error) => {
            if((error.message === 'Timeout' || error.message === 'Network request failed') && settings.retries < 5)
                return this.fetch_request({...settings, retries: (settings.retries + 1)});

            return Promise.resolve({status: false, response: error});
        });
    }
    
    save_callback(response)
    {
        if(response.status && response.data)
            this.commit_changes({data: response.data, delete_on_removed: true, extraData: response.extraData});
    }
    
    remove(settings)
    {
        settings = {...{force: false, apply_data_to_state: false}, ...settings}

        if(settings.force)
        {
            if(this.config.controller)
            {
                if(settings.apply_data_to_state)
                {
                    let model                            = {}
                    model[this.name]                     = {}
                    model[this.name][this.get_bind_id()] = {removed: 't'}
                    
                    this.config.controller.apply_models_to_state(model, null, settings);
                }
                
                if(this.config.controller.models[this.name] && this.config.controller.models[this.name][this.get_bind_id()])
                    delete this.config.controller.models[this.name][this.get_bind_id()];
            }
        }
        else
            this.set_field_data({field: 'removed', value: 't', ..._.omit(settings, ['field', 'value', 'force', 'apply_data_to_state'])});
    }
    
    undo_changes(settings)
    {
        if(!_.is_empty(this.start_data))
            this.data = _.cloneDeep(this.start_data);
        else
            this.data = {id: this.data.id};
        
        // Als je de name hebt aangepast moet die ook teniet worden gedaan.
        if(this.config.name != this.name)
            this.set_component_name(this.config.name);
        
        this.commit_changes(settings);
    }
    
    has_changes()
    {
        return (this.save_all_data() || this.data.removed == 't' || _.size(this.changed_data) > 0)
    }
    
    exists_in_state()
    {
        return (this.config.controller && this.config.controller.component.state.models && this.config.controller.component.state.models[this.name] && this.config.controller.component.state.models[this.name][this.get_bind_id()]);
    }
    
    clone_deep_callback(value)
    {
        if(value instanceof ReactModel)
            return value
    }
    
    get_bind_id()
    {
        return this.data[this.bind_id]
    }
}